export default (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 0-based index
  const day = date.getDate();
  
  const startAcademicYear = new Date(`${year}-09-01`);
  const endAcademicYear = new Date(`${year + 1}-05-25`);

  if (date >= startAcademicYear && date <= endAcademicYear) {
    return `${year}-${year + 1}`;
  } else if (date < startAcademicYear) {
    return `${year - 1}-${year}`;
  } else {
    return `${year}-${year + 1}`;
  }
};